import React from 'react';
import { useToast } from '../../contexts/ToastContext';
import Toast from './Toast';
import styles from './Toast.module.css';

const ToastContainer = () => {
  const { toasts, removeToast } = useToast();

  return (
    <div className={styles['toast-container']}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          toast={toast}
          onRemove={removeToast}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
